import { PhraseTriggerMessageSource } from "@edgetier/watchtower-types";
import { PhraseSearchFormValues } from "./phrase-search.types";
import { EXACT_SIMILARITY_THRESHOLD } from "../../select-similarity/select-similarity.utilities";

export const EMPTY_FIELD_GROUP: PhraseSearchFormValues[] = [
    {
        sentence: "",
        source: [PhraseTriggerMessageSource.Customer],
        similarityThreshold: EXACT_SIMILARITY_THRESHOLD,
    },
];

export const CLEAR_OPEN_SEARCH_GROUP = {
    search: "",
    searches: undefined,
    textSearchType: undefined,
    similarityThreshold: undefined,
    searchType: undefined,
    parameterGroupId: undefined,
};
export const EXACT_MESSAGE_SOURCES = [PhraseTriggerMessageSource.InteractionDetails, PhraseTriggerMessageSource.System];

// NON_EXACT_SIMILARITY_TYPES now lives in select-similarity.utilities, derived from SIMILARITY_ITEMS so a
// newly added option is picked up automatically. Re-exported here because this is where consumers of the
// phrase search look for it.
export { NON_EXACT_SIMILARITY_TYPES } from "../../select-similarity/select-similarity.utilities";
